import { useAppSelector } from 'redux/store';
import { HomepageHeaderFieldsFragment } from 'api/graphql-types';
import { Link } from 'components/link/link';
import IcnCarotRight from 'public/assets/icons/carot-right.svg';

import { Icon } from 'components/icon/icon';
import { Typography } from 'components/typography';
import Image from 'components/image';
import styles from './homepage-header.module.scss';

export interface IHomepageHeaderProps {
	module?: HomepageHeaderFieldsFragment;
}

const HomepageHeader = (props: IHomepageHeaderProps): React.JSX.Element => {
	const { showNeutralStyle } = useAppSelector((state) => state.settings);

	return (
		<div className={styles.homepageHeader}>
			<div className={styles.container}>
				<div className={styles.wrapper}>
					<div className={styles.headerImage}>
						{props.module?.backgroundImage?.data?.attributes?.url && (
							<Image
								className={styles.backgroundImage}
								attributes={props.module.backgroundImage.data.attributes}
								style={{ objectFit: 'cover' }}
								sizes="(max-width: 560px) 520px, (max-width: 1200px) 1185px, 840px"
								priority
								fill
							/>
						)}
						{!showNeutralStyle && (
							<div className={styles.bars}>
								<div />
								<div />
								<div />
							</div>
						)}
						<div className={styles.title}>
							<h1>{props.module?.homepageTitle}</h1>
						</div>
						{!showNeutralStyle && (
							<div className={styles.sidebars}>
								<div />
								<div />
								<div />
								<div />
							</div>
						)}
					</div>
					<div className={styles.content}>
						<div className={styles.description}>{props.module?.description}</div>
						<Typography className={styles.title} variant="p" tag="h2">
							{props.module?.popularHeader}
						</Typography>
						<div className={styles.links}>
							{props.module?.links?.map((link, index) => (
								<Link variant="tertiary-light" href={link?.href?.url} key={index}>
									<Icon customIcon={<IcnCarotRight />} size="12px" />
									<span className={styles.linkTitle}>{link?.href?.text || ''}</span>
								</Link>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HomepageHeader;
